export default function () {
  const submitDeleteApplicationForm = function () {
    event.preventDefault()
    if (confirm('Deleting an application is permanent, please confirm.')) {
      this.submit()
    } else {
      return false
    }
  }

  const deleteApplicationForms = document.getElementsByClassName('delete-application')
  for (const form of deleteApplicationForms) {
    form.addEventListener('submit', submitDeleteApplicationForm, false)
  }

  const submitDeleteProviderForm = function () {
    event.preventDefault()
    if (confirm('Deleting a provider is permanent, please confirm.')) {
      this.submit()
    } else {
      return false
    }
  }

  const deleteProviderForms = document.getElementsByClassName('delete-provider')
  for (const form of deleteProviderForms) {
    form.addEventListener('submit', submitDeleteProviderForm, false)
  }

  const submitDeleteResourceForm = function () {
    event.preventDefault()
    if (confirm('Deleting a resource is permanent, please confirm.')) {
      this.submit()
    } else {
      return false
    }
  }

  const deleteResourceForms = document.getElementsByClassName('delete-resource')
  for (const form of deleteResourceForms) {
    form.addEventListener('submit', submitDeleteResourceForm, false)
  }

  const submitDeleteRoleForm = function () {
    event.preventDefault()
    if (confirm('Deleting a role is permanent, please confirm.')) {
      this.submit()
    } else {
      return false
    }
  }

  const deleteRoleForms = document.getElementsByClassName('delete-role')
  for (const form of deleteRoleForms) {
    form.addEventListener('submit', submitDeleteRoleForm, false)
  }

  const submitDeletePermissionForm = function () {
    event.preventDefault()
    if (confirm('Deleting a permission is permanent, please confirm.')) {
      this.submit()
    } else {
      return false
    }
  }

  const deletePermissionForms = document.getElementsByClassName('delete-permission')
  for (const form of deletePermissionForms) {
    form.addEventListener('submit', submitDeletePermissionForm, false)
  }
}
